import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { LocalizeProvider } from 'react-localize-redux';
import DateFnsUtils from '@date-io/date-fns';
// import enLocale from "date-fns/locale/en-US";
import noLocale from 'date-fns/locale/nb';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import './app/style/styles.less';
import theme from './app/style/theme';
import App from './app/App';
import { actionCreators as PageSettingsActions } from './app/store/PageSettingStore';
import { setApiRoot } from './youwell-common/apiUrls';
import { configureStore, updateStore } from './youwell-common/reduxUtils';
import { reducers } from './app/store';
import { translateInitialization } from './app/localization';


const baseUrl = (window.serverParams && window.serverParams.baseUrl) || document.getElementById('react-app').getAttribute('data-base-url');
const apiUrl = (window.serverParams && window.serverParams.apiUrl) || document.getElementById('react-app').getAttribute('data-api-url');
const appVersion = (window.serverParams && window.serverParams.appVersion) || document.getElementById('react-app').getAttribute('data-app-version');
const appConfig = (window.serverParams && window.serverParams.appConfig) || JSON.parse(document.getElementById('react-app').getAttribute('data-app-config'));

if (!apiUrl) {
    throw new Error('Missing asp-prerender parameter: data-apiUrl');
}
setApiRoot(apiUrl);

// globals set in server-side rendering
const initialState = window.initialReduxState;

// Create browser history to use in the Redux store
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(reducers, history, initialState);

PageSettingsActions.setVersion(appVersion)(store.dispatch);
PageSettingsActions.setAppConfig(appConfig)(store.dispatch);

// Remove server-side generated jss
const jssStyles = document.getElementById('jss-server-side');
if (jssStyles && jssStyles.parentNode) {
    jssStyles.parentNode.removeChild(jssStyles);
}

const localizationInitialization = translateInitialization(appConfig.language);

const MainApp = () => (
    <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={noLocale}>
            <LocalizeProvider store={store} initialize={localizationInitialization}>
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <App />
                    </ConnectedRouter>
                </Provider>
            </LocalizeProvider>
        </MuiPickersUtilsProvider>
    </MuiThemeProvider>
);

const renderApp = () => {
    ReactDOM.render(
        <MainApp />,
        document.getElementById('react-app'),
    );
};

if (module.hot) {
    module.hot.accept('./app/store', () => {
        updateStore(store, reducers, history);
    });
}

renderApp();
